const EMPTY_BLOCK = /<(p|li|h[1-6])(\s[^>]*)?>((?:<(?:span|strong|em|b|i|u|s)\b[^>]*>)*)\s*((?:<\/(?:span|strong|em|b|i|u|s)>)*)<\/\1>/gi;

/**
 * An empty paragraph or heading as one blank line, the way the text editor shows it.
 * A browser gives an empty block no height; a <br> inside its innermost wrapper keeps
 * that wrapper's size.
 */
export function showEmptyLines(html) {
    if (!html || typeof html !== 'string') return html;
    return html.replace(EMPTY_BLOCK, (match, tag, attrs = '', open, close) => `<${tag}${attrs}>${open}<br>${close}</${tag}>`);
}
